/**
 * Public URL prefix for axios + React Router (baked in at `npm run build`).
 *
 * Product / path install:  PUBLIC_URL=/mantis   (client/package.json homepage)
 * GOTS subdomain root:     PUBLIC_URL=/         (mantis.greenfield.energy)
 */
const raw = process.env.REACT_APP_PUBLIC_BASE ?? process.env.PUBLIC_URL ?? '/';
export const PUBLIC_BASE = raw === '/' ? '' : String(raw).replace(/\/$/, '');
